import type { BackendUser } from '../../../services/user/userService';
import { canAccessRecipesPage } from '../../../services/accessManagement/accessManagement';

export function canAccessRecipeViewer(
  restaurantId: string | undefined,
  user: BackendUser | null,
  accountSettings: string[],
): boolean {
  return !!restaurantId && canAccessRecipesPage(user, accountSettings);
}

export function getRecipeViewerReturnPath(value: unknown): string | null {
  if (typeof value !== 'string' || /[\\\r\n]/.test(value)) return null;
  return /^\/recipe-viewer\/[a-zA-Z0-9_-]+(?:[/?]|$)/.test(value) ? value : null;
}
